import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import './TableWrapper.css';

const TableWrapper = ({ children, maxHeight = "600px" }) => {
  const [popup, setPopup] = useState(null); // { text, left, top, width }
  const wrapperRef = useRef(null);

  useEffect(() => {
    const table = wrapperRef.current?.querySelector("table");
    if (!table) return;

    const handleCellClick = (e) => {
      if (e.target.tagName !== "TD") return;
      const cell = e.target;
      // Check for overflow
      if (cell.scrollWidth > cell.clientWidth) {
        const rect = cell.getBoundingClientRect();
        setPopup({
          text: cell.innerText,
          left: rect.left + window.scrollX,
          top: rect.bottom + window.scrollY + 4,
          width: Math.max(rect.width, 200),
        });
      } else {
        setPopup(null);
      }
    };
    table.addEventListener("click", handleCellClick);
    return () => table.removeEventListener("click", handleCellClick);
  }, []);

  useEffect(() => {
    if (!popup) return;
    const handleDocClick = (e) => {
      // Close if click outside popup
      if (!e.target.closest('.table-cell-popup')) setPopup(null);
    };
    document.addEventListener('mousedown', handleDocClick);
    return () => document.removeEventListener('mousedown', handleDocClick);
  }, [popup]);

  const style = {
    marginBottom: "1rem",
    border: "1px solid #dee2e6",
    borderRadius: "4px",
    padding: "0.5rem",
    width: "100%",
    overflowX: "auto",
    boxSizing: "border-box",
  };

  return (
    <div className="table-wrapper" style={style} ref={wrapperRef}>
      {children}
      {popup && ReactDOM.createPortal(
        <div
          className="table-cell-popup"
          style={{
            position: 'absolute',
            left: popup.left,
            top: popup.top,
            minWidth: popup.width,
            zIndex: 9999,
            background: '#fff',
            border: '1px solid #ccc',
            borderRadius: 6,
            padding: '8px 16px',
            boxShadow: '0 2px 12px rgba(0,0,0,0.18)',
            maxWidth: 500,
            wordBreak: 'break-word',
          }}
        >
          {popup.text}
        </div>,
        document.body
      )}
    </div>
  );
};

export default TableWrapper;